import {Route} from 'react-router';
import {authCheck, salesforceAuthCheck} from 'components/routes/Router.utils';
import React from 'react';
import LiveCoachingContainer from 'components/pure/scorecards/live-coaching/LiveCoachingContainer';
import OAuthCallbackPage from 'components/OAuthCallback';
import {ExternalSharePage} from '@components/call-card/external/ExternalSharePage';

/**
 * Routes that don't fit into any other files
 */
export const miscRoutes = (
  <>
    {/* Related to iFrame Busting for Salesforce: Need to check ev-auth-workflow for from_salesforce endpoints */}
    <Route path="/apiv2/from_salesforce" onEnter={salesforceAuthCheck} />
    <Route path="/from_salesforce" onEnter={salesforceAuthCheck} />

    {/* live coaching route*/}
    <Route path="live-coaching" component={LiveCoachingContainer} onEnter={authCheck} />

    <Route path="oauth_callback" component={OAuthCallbackPage} onEnter={authCheck} />

    {/* external call route*/}
    <Route path="externalCallShared/:permalink" component={ExternalSharePage} />
  </>
);
